import ApiService from './ApiService'
import type { NoteKeyWrapperPayload } from './CryptoService'

/** Response shape from GET /note/{noteId}/key-wrapper */
export type NoteKeyWrapperResponse = {
    wrapped_key: string
    nonce: string
    alg: string
}

/**
 * Fetch the note key wrapper for the current user.
 *
 * @param noteId - UUID of the note.
 * @returns      - The wrapper data needed to unwrap the note key.
 * @throws       - 404 if no wrapper exists, 403 for non-owner.
 */
export async function apiGetNoteKeyWrapper(noteId: string) {
    return ApiService.fetchDataWithAxios<NoteKeyWrapperResponse>({
        url: `/app/v1/note/${noteId}/key-wrapper`,
        method: 'get',
    })
}

/**
 * Persist a note key wrapper on the server.
 *
 * The server will return 409 if a wrapper already exists for this user+note.
 * Callers should treat 409 as a non-fatal outcome (stale local state).
 *
 * @param noteId  - UUID of the note.
 * @param payload - Wrapped key payload produced by `wrapNoteKey()`.
 */
export async function apiStoreNoteKeyWrapper(
    noteId: string,
    payload: NoteKeyWrapperPayload,
) {
    return ApiService.fetchDataWithAxios<{ message: string }>({
        url: `/app/v1/note/${noteId}/key-wrapper`,
        method: 'post',
        data: payload,
    })
}

const NoteKeyWrapperService = {
    apiGetNoteKeyWrapper,
    apiStoreNoteKeyWrapper,
}

export default NoteKeyWrapperService

